var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAppAesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 5,
    fill: "#F7971E",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 57.5,
    height: 57.5,
    rx: 4.75,
    stroke: "#2A85FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5002 21.105C32.109 21.105 34.2211 23.2171 34.2211 25.8259C34.2211 28.4347 32.109 30.5468 29.5002 30.5468C26.8913 30.5468 24.7792 28.4347 24.7792 25.8259C24.7792 23.2171 26.8913 21.105 29.5002 21.105V21.105ZM24.2491 32.4267H34.7595V33.8511H24.2491V32.4267ZM25.889 36.8992H33.1115V35.483H25.889V36.8992ZM39 39.9802V44.8337C39 46.0263 38.0226 47.0037 36.8382 47.0037H22.1701C20.9774 47.0037 20 46.0263 20 44.8337V13.1701C20 11.9774 20.9774 11 22.1701 11H36.8382C38.0226 11 39 11.9774 39 13.1701V39.9802ZM36.9956 41.8685V16.1352H22.0048V41.8685H36.9956ZM25.7067 12.8389C26.1125 12.8389 26.4355 13.1702 26.4355 13.5677C26.4355 13.9653 26.1126 14.2965 25.7067 14.2965C25.3092 14.2965 24.9862 13.9653 24.9862 13.5677C24.9862 13.1702 25.3092 12.8389 25.7067 12.8389ZM28.2495 13.013H33.4508C33.7655 13.013 34.0141 13.2696 34.0141 13.5846C34.0141 13.8909 33.7657 14.1479 33.4508 14.1479H28.2495C27.9348 14.1479 27.6779 13.8912 27.6779 13.5846C27.6779 13.2699 27.9346 13.013 28.2495 13.013ZM29.5002 43.0365C30.2704 43.0365 30.8998 43.6658 30.8998 44.4361C30.8998 45.2063 30.2704 45.8357 29.5002 45.8357C28.7299 45.8357 28.1005 45.2063 28.1005 44.4361C28.1005 43.6659 28.7299 43.0365 29.5002 43.0365ZM29.5002 22.4882C31.3471 22.4882 32.838 23.979 32.838 25.8261C32.838 27.6647 31.3473 29.164 29.5002 29.164C27.6616 29.164 26.1623 27.665 26.1623 25.8261C26.1623 23.9792 27.6613 22.4882 29.5002 22.4882Z",
    fill: "url(#paint0_linear_906_2182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_906_2182",
    x1: 24.8331,
    y1: 16.6741,
    x2: 53.1539,
    y2: 25.3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppAesign);
export default __webpack_public_path__ + "static/media/mobile-app-aesign.d856c5c37d7af1e265ed80b81175d824.svg";
export { ForwardRef as ReactComponent };